import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ApplicationService {

    private _previousMode: string;
    // get/set
    private _appStarted = false;

    // get
    private _mode = 'default';

    constructor() {
        // this.controlService.getDrawMode().subscribe((res) => {
        //     this._drawMode = (res as any);
        // });
        // this.controlService.getMeasureMode().subscribe((res) => {
        //     this._measureMode = (res as any);
        // });
    }


    get appStarted(): boolean {
        return this._appStarted;
    }

    set appStarted(value: boolean) {
        this._appStarted = value;
    }

    get mode(): string {
        return this._mode;
    }

    set measureMode(value: boolean) {
        if (value) {
            this._mode = 'measureMode';
        } else {
            this._mode = 'default';
        }
    }

    set infoMode(value: boolean) {
        if (value) {
            this._mode = 'infoMode';
        } else {
            this._mode = 'default';
        }
    }

    set drawMode(value: boolean) {
        if (value) {
            this._mode = 'brushMode';
        } else {
            this._mode = 'default';
        }
    }

    deactivateAll() {
        this._mode = 'default';
    }

// -------------------------------------------------------------------------------------------------------------------------------------

    /**
     * (Un-)sets the draw view as the active view
     */
    public activateMode(active: boolean) {
        if (!active) {
            this._mode = this._previousMode;
            this._previousMode = 'default';
        } else {
            this._previousMode = this._mode;
            this._mode = 'default';
        }
    }

}
